import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelVariantSetpoints.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import ModelVariantSetpoints from './ModelVariantSetpoints';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getModelVariantManager } from '../../selectors/index';
import Cookies from 'js-cookie';


const ModelVariantSetpointListTable = ({
  setEditHandler,
  selectedModelSetpointId,
  defaultHandler,
  saveModelVariantSetpoint,
  modelVariantSetpoints,
  changeModelVariantSetpoint,
  paginatedData = [],
  UpdateAllowed,
  disableMode,
  disableModeHandler,
  IsModelCategoryOwner
}) => {

  let { ModelVariantId } = useParams()
  const modelVariantManager = useSelector(state => getModelVariantManager(state));
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  const fetchDataHandler = (modelVariantSetpointId, modelSetpointId) => {
    setEditHandler(modelSetpointId);
    disableModeHandler(true);
    let selectedSetpoint = modelVariantSetpoints.SetpointsList.find(item => item.ModelSetpointId == modelSetpointId)
    changeModelVariantSetpoint({
      ...modelVariantSetpoints,
      SelectedSetpoint: {
        ModelVariantSetpointId: modelVariantSetpointId || 0,
        ModelVariantId: ModelVariantId,
        ...selectedSetpoint
      }

    })
  };

  const cancelHandler = () => {
    setEditHandler(-1);
    disableModeHandler(false);
  };

  const editModelContent = (
    <ModelVariantSetpoints
      ModelSetpointId={selectedModelSetpointId}
      saveModelVariantSetpoint={saveModelVariantSetpoint}
      modelVariantSetpoints={modelVariantSetpoints}
      changeModelVariantSetpoint={changeModelVariantSetpoint}
      defaultHandler={defaultHandler}
      cancelHandler={cancelHandler}
    />);

  let editorMain = (
    <tr>
      <td colSpan="10">{editModelContent}</td>
    </tr>
  );

  const isModelVariantOwner = () => {
    const modelVariantOrgId = (modelVariantManager.selectedModelVariant ? modelVariantManager.selectedModelVariant.OrganisationId : '') || '';
    const userOrgId = Cookies.get(`selectedorganisationid-${envName}`) || 1;

    if (modelVariantOrgId == userOrgId) {
      return true
    }

    return false;
  }


  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="modelSetpoints.setpointGroup" defaultMessage="Setpoint Group" />
            </th>
            <th>
              <FormattedMessage id="modelVariantSetpoints.name" defaultMessage="Name" />
            </th>
            <th>
              <FormattedMessage id="modelVariantSetpoints.code" defaultMessage="Code" />
            </th>
            <th>
              <FormattedMessage id="modelVariantSetpoints.value" defaultMessage="Value" />
            </th>
            <th>
              <FormattedMessage id="modelVariantSetpoints.uOM" defaultMessage="Unit of Measure" />
            </th>

            {UpdateAllowed && isModelVariantOwner() && <th></th>}
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <Fragment key={n.ModelSetpointId}>
                <tr key={n.ModelSetpointId} data-unittest="modelVariantSetpointData">
                  <td>{n.SetpointGroup}</td>
                  <td>{n.Name}</td>
                  <td>{n.Code}</td>
                  <td>{n.Value}</td>
                  <td>{n.UnitOfMeasure}</td>
                  {isModelVariantOwner() && UpdateAllowed && (
                    <td className={s.btnCol}>
                      {n.IsEditable && UpdateAllowed && (
                        <Button
                          variant="outline-secondary"
                          className={s.changeButton}
                          href="#"
                          onClick={() => fetchDataHandler(n.ModelVariantSetpointId, n.ModelSetpointId)}
                          disabled={disableMode}
                          data-unittest="changeData"
                        >
                          <FormattedMessage id="common.ledit" defaultMessage="Edit" />
                        </Button>
                      )}
                    </td>
                  )}
                </tr>
                {modelVariantSetpoints.showAddEditScreen && modelVariantSetpoints.SelectedSetpoint.ModelSetpointId == n.ModelSetpointId && editorMain}
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


ModelVariantSetpointListTable.propTypes = {
  setEditHandler: PropTypes.func.isRequired,
  selectedModelSetpointId: PropTypes.number,
  saveModelVariantSetpoint: PropTypes.func.isRequired,
  modelVariantSetpoints: PropTypes.object.isRequired,
  describeModelVariantSetpoint: PropTypes.func.isRequired,
  changeModelVariantSetpoint: PropTypes.func.isRequired,
  paginatedData: PropTypes.array,
  UpdateAllowed: PropTypes.bool,
  disableMode: PropTypes.bool,
  disableModeHandler: PropTypes.func.isRequired
};

export default injectIntl(ModelVariantSetpointListTable);
